const _version = "2.4.0 (ee53d1bfe8eaaf0148132e92c5e81e4e2a590a62)"

function version() {
    return _version;
}

export default version







